// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__E0hkc"};